import * as classNames from 'classnames'
import * as React from 'react'
import SafeInnerHtml from '../safeInnerHtml'
import TextLink from '../textLink'

export interface IProps {
  TagName?: string
  heading: string
  subHeading: string
  searchDescription?: string
  styles?: { [key: string]: string }
}

interface IState {
  expanded: boolean
}

class SeoHeadings extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      expanded: false
    }
  }

  public render() {
    const {
      TagName = 'h1',
      heading,
      subHeading,
      searchDescription,
      styles = {}
    } = this.props

    const { expanded } = this.state
    const readMoreText = expanded ? 'Read less' : 'Read more'

    return (
      <div
        className={styles.seoHeadingContainer}
        data-test-selector="SeoHeadings"
      >
        <SafeInnerHtml
          Tag={TagName}
          className={styles.seoHeading}
          html={heading}
        />
        {subHeading && (
          <SafeInnerHtml
            Tag="h2"
            className={styles.seoSubHeading}
            html={subHeading}
          />
        )}
        {searchDescription && (
          <TextLink
            onClick={this.toggleExpanded}
            className={styles.seoSearchDescriptionReadMoreButton}
          >
            {readMoreText}
          </TextLink>
        )}
        {searchDescription && expanded && (
          <SafeInnerHtml
            className={classNames(
              'fds-c-text-preformatted',
              styles.seoSearchDescription
            )}
            html={searchDescription}
          />
        )}
      </div>
    )
  }

  public componentDidUpdate = (nextProps: IProps) => {
    if (nextProps.searchDescription !== this.props.searchDescription) {
      this.setState({ expanded: false })
    }
  }

  private toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded })
  }
}

export default SeoHeadings
